import { Autocomplete, TextField } from '@mui/material';
import React from 'react';

const CustomAutoComplete = ({ list, value, handleChange }) => (
  <Autocomplete
    multiple
    id="multiple-limit-tags"
    name="tags"
    options={list}
    size="small"
    getOptionLabel={(option) => option.title}
    isOptionEqualToValue={(op, val) => op.id === val.id}
    defaultValue={value}
    filterSelectedOptions
    renderInput={(params) => (
      <TextField
        {...params}
        placeholder="Tags"
        disableUnderline
        InputProps={{
          ...params.InputProps,
          sx: {
            backgroundColor: 'white',
            padding: '0px',
            border: '1px solid #f4f4f4',
            borderRadius: '10px',
          },
        }}
        width="100%"
      />
    )}
    onChange={handleChange}
  />
);

export default CustomAutoComplete;
